.page.product-type-page {
  /** Make multi column on large screens **/
  .product-listing {
    font-size: 0.9em;
    @media (min-width: 32rem) {
      font-size: 1em;
    }
    &.multi-col {
      @media (min-width: 48rem) {
        column-count: 2;
      }
      @media (min-width: 75rem) {
        column-count: 3;
      }
    }
  }
  /** Increase touch target size on touch devices **/
  @media (pointer: coarse) {
    li {
      margin: 2em 0;
    }
  }

  .product-filter-field-container {
    position: relative;

    input, .inner-icon {
      transition: all .25s ease-in-out;
    }

    &.empty, &.empty input {
      color: var(--bs-danger);
      border-color: var(--bs-danger);
    }

    &.active, &.active input {
      color: var(--bs-primary);
      border-color: var(--bs-primary);
    }

    .product-filter-field {
      font-size: 1.3em;
      padding: .7em;
      padding-left: 2em;
      line-height: 1em;
      border: 1px solid var(--bs-bjelin-grey);
      border-radius: 1rem;
      width: 100%;
      max-width: 25rem;
      margin-bottom: 1em;

      /** Decrease font size on small screens **/
      @media (max-width: 32rem) {
        font-size: 1em;
        padding-left: 1.7em;
      }
    }

    /** Inner icon inside field **/
    .inner-icon {
      position: absolute;
      left: .8em;
      top: 1em;
      font-size: 1.2em;
      @media (max-width: 32rem) {
        font-size: 0.8em;
        top: 1.25em;
      }
    }
  }

  ul.product-listing, ul.guide-listing, ul.document-listing {
    list-style: none;
    margin-left: 0;

    li {
      a {
        color: inherit;

        &:hover {
          color: black;
          span {
            color: var(--bs-bjelin-middlegrey);
          }
        }
      }
    }
  }

}
